import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// CLAIM_CHANGE_STATUS

const mutation = gql`
  mutation claimChangeState($id: ID!, $status: CLAIM_STATUS!) {
    claimChangeState(id: $id, status: $status) {
      id
      claim_status: status
    }
  }
`

export default function useClaimChangeState(
  successMessage = 'Claim is updated'
) {
  const { onMutate: onClaimChangeState, loading } = useSafeRunMutation({
    mutation,
    successMessage,
    responsePath: 'claimChangeState'
  })
  return { onClaimChangeState, loading }
}
